/**
 * Commuter starter template.
 *
 * Persona: person who commutes, wants to know weather + local news + market pulse.
 * Tile mix: weather (2×2), clock (1×1), nation news (2×2), SPY markets (1×1).
 * The weather coords default to San Francisco — the user updates them in edit mode.
 */
import { BOARD_SCHEMA_VERSION, TILE_SCHEMA_VERSION } from 'briefpane/schema';

export const COMMUTER_BOARD_RAW: unknown = {
  schemaVersion: BOARD_SCHEMA_VERSION,
  id: 'board_commuter',
  createdAt: '2026-07-24T00:00:00.000Z',
  updatedAt: '2026-07-24T00:00:00.000Z',
  grid: { cols: 8, rowHeight: 120, gap: 12 },
  layout: [
    { tileId: 'tile_cmwx01', x: 0, y: 0, w: 2, h: 2 },
    { tileId: 'tile_cmclk1', x: 2, y: 0, w: 1, h: 1 },
    { tileId: 'tile_cmnws1', x: 3, y: 0, w: 2, h: 2 },
    { tileId: 'tile_cmmkt1', x: 2, y: 1, w: 1, h: 1 },
  ],
  tiles: [
    {
      v: TILE_SCHEMA_VERSION,
      id: 'tile_cmwx01',
      type: 'weather.current',
      source: {
        provider: 'openweathermap',
        params: { lat: 37.77, lon: -122.42, units: 'imperial' },
      },
      refresh: { intervalSec: 900 },
      display: { size: '2x2', variant: 'big-number' },
      glance: { primary: 'tempF', delta: 'vsYesterdayF', state: 'condition' },
      label: 'Weather',
    },
    {
      v: TILE_SCHEMA_VERSION,
      id: 'tile_cmclk1',
      type: 'clock.local',
      source: { provider: 'local', params: { tz: 'America/Los_Angeles', format: '12h' } },
      display: { size: '1x1', variant: 'big-number' },
      glance: { primary: 'time', delta: 'date', state: null },
      label: 'Clock',
    },
    {
      v: TILE_SCHEMA_VERSION,
      id: 'tile_cmnws1',
      type: 'news.headlines',
      source: { provider: 'gnews', params: { topic: 'nation', count: 5 } },
      refresh: { intervalSec: 600 },
      display: { size: '2x2', variant: 'list' },
      glance: { primary: 'headline', delta: 'source', state: null },
      label: 'News',
    },
    {
      v: TILE_SCHEMA_VERSION,
      id: 'tile_cmmkt1',
      type: 'markets.quote',
      source: {
        provider: 'finnhub',
        params: { symbols: ['SPY'], display: 'change' },
      },
      refresh: { intervalSec: 60 },
      display: { size: '1x1', variant: 'big-number' },
      glance: { primary: 'price', delta: 'changePct', state: 'direction' },
      label: 'S&P 500',
    },
  ],
};
